import { AlertDialog, Button, useControllableState } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface DeleteClientDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isLoading: boolean
}

export const DeleteClientDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isLoading,
}: DeleteClientDialogProps): JSX.Element => {
  const [isOpenState, setIsOpenState] = useControllableState({
    prop: open,
    defaultProp: false,
    onChange: onOpenChange,
  })

  return (
    <AlertDialog open={isOpenState} onOpenChange={setIsOpenState}>
      <AlertDialog.Content>
        <AlertDialog.Title>Delete App Client</AlertDialog.Title>
        <AlertDialog.Description>
          Are you sure you want to delete this app client? All associated
          credentials and access tokens will be permanently revoked. Any
          applications using this client will immediately stop working. This
          action cannot be undone.
        </AlertDialog.Description>

        <AlertDialog.Actions>
          <AlertDialog.Cancel>
            <Button variant="tertiary">Cancel</Button>
          </AlertDialog.Cancel>

          <Button variant="critical" onClick={onConfirm} loading={isLoading}>
            Delete Client
          </Button>
        </AlertDialog.Actions>
      </AlertDialog.Content>
    </AlertDialog>
  )
}
